import { EnumBase } from '../models/enum-base.model';

export class SimNaoEnum extends EnumBase {
    constructor() {
        super([
            { value: true, name: 'Sim' },
            { value: false, name: 'Não' },
        ]);
    }
}